import { Box,Table, TableBody, TableHead,TableContainer,TableCell,
     Pagination, TableRow, IconButton, Paper, 
	 Typography} from "@mui/material"
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useState, useEffect } from 'react';
import ModalEditDelete from './ModalCatalogs/ModalEditDelete';
import { useLocation } from 'react-router-dom';

function createData(id, customer, material, quantity, plant, crossReference, createdDate) {
    return {id, customer, material, quantity, plant, crossReference, createdDate}
  }

  
  const rowHeaderAux = [
      "Id",
      "Customer",
      "Material",
      "Quantity",
      "Plant",
      "Cross Reference",
	  "Storage Location",
      "Created Date", 
      "Edit", 
      "Delete"
  ]

const rowHeaderAuxDos = [
	"Id",
	"Customer",
	"Material",
	"Quantity",
	"Plant",
	"Availability Date",
	"Created Date",
	"Edit",
	"Delete"
]

const TableContent = ({ offset, handleChange, pageSize, products, fetchData, title}) => {
	const [openModal, setOpenModal] = useState(false)
    const [tabValue, setTabValue] = useState(0)
	const [typeModel, setTypeModal] = useState("");
	const [product, setProduct] = useState(null);
    const handleOpenModalEdit = (row) => { setOpenModal(true); setTypeModal("Edit"); setProduct(row)}
	const handleOpenModalDelete = (row) => { setOpenModal(true); setTypeModal("Delete"); setProduct(row) }
    const handleCloseModal = () => { setOpenModal(false) }
    const handleChangeTap = (event, newValue) => { setTabValue(newValue) }

	const location = useLocation();
	const {  pathname } = location;
	const [rowHeader, setRowHeader] = useState([])
	const [showExtraColumns, setShowExtraColumns] = useState(true);

	const loadHeaders = () => {
		if (pathname === "/dashboard/products/CotscoProd" || pathname === "/dashboard/products/GenericProd"){
			setRowHeader(rowHeaderAuxDos);
			setShowExtraColumns(false);
		}else{
			setRowHeader(rowHeaderAux);
			setShowExtraColumns(true);
		}
		
	}

	useEffect(() => {
		loadHeaders();
	}, [pathname])

    return (
        <Box component="section" sx={{ margin: 5}}>
			<Typography variant="h4" sx={{ textAlign: "center", marginBottom: "10px" }} color="primary">{title}</Typography>
			<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
				<TableRow>
					{rowHeader.map((row, index) =>(
						<TableCell align="center" key={index}>{row}</TableCell>
					))}
				</TableRow>
				</TableHead>
				<TableBody>
				{products.map((row, index) => (
					<TableRow
					key={index}
					sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
					>
					<TableCell align="center" component="th" scope="row">
						{row.id}
					</TableCell>
					<TableCell align="center">{row.customer}</TableCell>
					<TableCell align="center">{row.material}</TableCell>
					<TableCell align="center">{row.quantity}</TableCell>
					<TableCell align="center">{row.plant}</TableCell>						
					{showExtraColumns && (
						<>
							<TableCell align="center">{row.crossReference}</TableCell>
							<TableCell align="center">{row.storageLocation}</TableCell>
						</>
					)}
					{!showExtraColumns && (
						<>
							<TableCell align="center">{row.availabilityDate}</TableCell>							
						</>
					)}
					<TableCell align="center">{row.createdDate}</TableCell>
					<TableCell align="center"><IconButton aria-label="edit" onClick={() => handleOpenModalEdit(row)}><EditIcon color="primary"/></IconButton></TableCell>
					<TableCell align="center"><IconButton aria-label="delete" onClick={() => handleOpenModalDelete(row)}><DeleteIcon color="error"/></IconButton></TableCell>
					</TableRow>
				))}
				</TableBody>
			</Table>
			</TableContainer>
			<Box display="flex" justifyContent="center" component="div" sx={{ marginTop: 5}}>
				<Pagination count={pageSize} page={offset+1} onChange={handleChange} />
			</Box>

			<ModalEditDelete 
                            openModal={openModal}
                            handleCloseModal={handleCloseModal}
                            tabValue={tabValue}
                            handleChangeTap={handleChangeTap}
                            pathname={pathname}
							typeModal={typeModel}
							productOject={product}
							fetchData={fetchData}
                        />
		</Box>
    )
}

export default TableContent;